import React, { useState } from 'react';

interface DataStoreProps {
  children: any;
}

export const DataStoreContext = React.createContext<any | undefined>(undefined);

export var setOnlineUsers: any;

export var inviteFailedSetter: any;
export var inviteUsernameSetter: any;
export var waitingForPlayerSetter: any;
export var gameActiveSetter: any;

export const DataStore: React.FC<DataStoreProps> = ({ children }) => {

  const [onlineUsers, setterOnlineUsers] = useState<any | undefined>(undefined);
  setOnlineUsers = setterOnlineUsers;

  const [waitingForPlayer, setWaitingForPlayer] = useState<boolean>(false);
  waitingForPlayerSetter = setWaitingForPlayer;
  const [inviteFailed, setInviteFailed] = useState<boolean>(false);
  inviteFailedSetter = setInviteFailed;
  const [inviteUsername, setInviteUsername] = useState<string | undefined>(undefined);
  inviteUsernameSetter = setInviteUsername;
  const [gameActive, setGameActive] = useState<boolean>(false);
  gameActiveSetter = setGameActive;

  const data = {
    onlineUsers: onlineUsers,
    game: {
      waitingForPlayer,
      inviteFailed,
      inviteUsername,
      gameActive
    }
  }

  return (
    <DataStoreContext.Provider value={data}>
      {children}
    </DataStoreContext.Provider>
  );
}
